import { CheckResourcesResponse } from '@cerbos/core';
import { Observable } from 'rxjs';

export abstract class AbstractPermissionService {
    abstract init: () => Promise<void>;

    abstract loadAllPermissions: (principal: {
        subject?: string;
        roles?: string[];
    }) => Observable<CheckResourcesResponse | undefined>;

    abstract clearPermissions: () => void;
}
